<template>
  <div
    class="service-item"
    @click="$emit('click')"
  >
    <div
      v-if="showIcon"
      class="service-item-image-wrapper"
    >
      <div
        v-if="currentService.file && currentService.file.file_url"
        class="service-item__image"
        :style="{ backgroundImage: `url(${currentService.file.file_url})`}"
      />

      <template v-else>
        <svg
          width="48"
          height="54"
          viewBox="0 0 48 54"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M45.3333 53.6667H2.66667C1.95942 53.6667 1.28115 53.3857 0.781048 52.8856C0.280951 52.3855 0 51.7073 0 51V3.00001C0 2.29277 0.280951 1.61449 0.781048 1.11439C1.28115 0.614295 1.95942 0.333344 2.66667 0.333344H45.3333C46.0406 0.333344 46.7189 0.614295 47.219 1.11439C47.7191 1.61449 48 2.29277 48 3.00001V51C48 51.7073 47.7191 52.3855 47.219 52.8856C46.7189 53.3857 46.0406 53.6667 45.3333 53.6667ZM42.6667 48.3333V5.66668H5.33333V48.3333H42.6667ZM13.3333 13.6667H34.6667V19H13.3333V13.6667ZM13.3333 24.3333H34.6667V29.6667H13.3333V24.3333ZM13.3333 35H26.6667V40.3333H13.3333V35Z"
            fill="#3C3C43"
            fill-opacity="0.6"
          />
        </svg>
      </template>
    </div>

    <p
      ref="serviceName"
      class="service-item__name"
      :style="{
        fontSize: serviceNameFontSize
      }"
    >
      {{ currentServiceName || fallbackTranslationName }}
    </p>

    <div
      v-if="$store.deviceStartData.unit_settings.show_count_of_visitors && $store.serviceVisitorsCount[item.id]"
      class="service-visitors"
    >
      <svg
        width="21"
        height="22"
        viewBox="0 0 21 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 21.5C0 19.3783 0.842855 17.3434 2.34315 15.8431C3.84344 14.3429 5.87827 13.5 8 13.5C10.1217 13.5 12.1566 14.3429 13.6569 15.8431C15.1571 17.3434 16 19.3783 16 21.5H14C14 19.9087 13.3679 18.3826 12.2426 17.2574C11.1174 16.1321 9.5913 15.5 8 15.5C6.4087 15.5 4.88258 16.1321 3.75736 17.2574C2.63214 18.3826 2 19.9087 2 21.5H0ZM8 12.5C4.685 12.5 2 9.815 2 6.5C2 3.185 4.685 0.5 8 0.5C11.315 0.5 14 3.185 14 6.5C14 9.815 11.315 12.5 8 12.5ZM8 10.5C10.21 10.5 12 8.71 12 6.5C12 4.29 10.21 2.5 8 2.5C5.79 2.5 4 4.29 4 6.5C4 8.71 5.79 10.5 8 10.5ZM16.284 14.203C17.6893 14.8359 18.882 15.8612 19.7186 17.1557C20.5552 18.4502 21.0002 19.9587 21 21.5H19C19.0002 20.344 18.6666 19.2125 18.0391 18.2416C17.4116 17.2707 16.5171 16.5017 15.463 16.027L16.283 14.203H16.284ZM15.596 2.913C16.6035 3.3283 17.465 4.03354 18.071 4.93923C18.6771 5.84492 19.0004 6.91024 19 8C19.0004 9.37233 18.4877 10.6952 17.5625 11.7088C16.6374 12.7224 15.3667 13.3535 14 13.478V11.465C14.7409 11.3589 15.4283 11.018 15.9613 10.4925C16.4943 9.9669 16.8447 9.28432 16.9612 8.54493C17.0776 7.80555 16.954 7.0483 16.6084 6.38435C16.2628 5.72041 15.7134 5.18475 15.041 4.856L15.596 2.913Z"
          fill="#3C3C43"
          fill-opacity="0.3"
        />
      </svg>
      <p>{{ $store.serviceVisitorsCount[item.id] }}</p>
    </div>
  </div>
</template>

<script>
import ServiceItemMixin from '../mixins/ServiceItemMixin';

export default {
  name: 'ServiceItem',
  mixins: [ServiceItemMixin],
  computed: {
    currentService() {
      return this.$store.services[this.item.service.id];
    },
    currentServiceName() {
      return this.currentService.name[this.$store.currentLanguage.tag];
    },
    fallbackTranslationName() {
      return this.currentService.fallbackTranslationName;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../styles/ServiceItem.scss';
@import '../../../../styles/variables.scss';

.service-visitors {
  display: flex;
  align-items: center;
  margin-left: auto;
  white-space: nowrap;

  svg {
    width: max(1.640625vw, 21px);
  }

  p {
    color: $color-label-tetriary;
    margin-left: 4px;
    font-size: max(1.875vw, 24px);
  }
}
</style>